export const siteUrl = 'https://kroemtech.ch'

// Social cards want ~1200x630. The logo previously used here is 643x110 and
// rendered as a thin strip in every preview.
export const ogImage = `${siteUrl}/img/og/kroemtech-og.jpg`

/** Schema.org Service node for a service or solution page. */
export const serviceSchema = (p: {
  name: string
  description: string
  url: string
}) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: p.name,
  description: p.description,
  url: p.url,
  provider: {
    '@type': 'Organization',
    name: 'KROEMTECH GmbH',
    url: siteUrl
  },
  areaServed: { '@type': 'Country', name: 'Switzerland' }
})

/** Schema.org Article node for a blog post. */
export const articleSchema = (p: {
  headline: string
  description: string
  url: string
}) => ({
  '@context': 'https://schema.org',
  '@type': 'Article',
  headline: p.headline,
  description: p.description,
  url: p.url,
  mainEntityOfPage: { '@type': 'WebPage', '@id': p.url },
  image: ogImage,
  author: { '@type': 'Organization', name: 'KROEMTECH GmbH', url: siteUrl },
  publisher: {
    '@type': 'Organization',
    name: 'KROEMTECH GmbH',
    url: siteUrl,
    logo: {
      '@type': 'ImageObject',
      url: `${siteUrl}/img/logos/kroemtech/kroemtech_logo_white_640px.png`
    }
  }
})

export const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: 'KROEMTECH GmbH',
  url: siteUrl,
  logo: ogImage,
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Christoph Merian-Ring 11',
    addressLocality: 'Reinach',
    postalCode: '4153',
    addressCountry: 'CH'
  },
  telephone: '+41-61-717-8245'
}
